import React, { Suspense } from 'react';

const ExecutionStreamRemote = React.lazy(async () => {
  // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
  const module = await import('kciWorkspace/ExecutionStreamPage');
  const component =
    module.ExecutionStreamPage ?? module.default?.ExecutionStreamPage ?? module.default;

  if (!component) {
    throw new Error('ExecutionStreamPage export not found in kciWorkspace/ExecutionStreamPage');
  }

  return { default: component as React.ComponentType };
});

export const RemoteExecutionStreamDashboard = React.memo(function RemoteExecutionStreamDashboard() {
  return (
    <Suspense fallback={<div className="body-content">Loading Execution Stream…</div>}>
      <ExecutionStreamRemote />
    </Suspense>
  );
});

export default RemoteExecutionStreamDashboard;
